<div class="main-layout">
  <div class="main-header-container">
    <app-quotation-top-header></app-quotation-top-header>
    <app-quotation-header (collapsedState)="onHeaderCollapse($event)"></app-quotation-header>
  </div>

  <div class="content-wrapper" [class.expanded]="!isHeaderCollapsed" [class.collapsed]="isHeaderCollapsed">
    <div class="kikf1-container">
      <p-toast></p-toast>
      <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

      <!-- Global Loading Overlay -->
      <div *ngIf="loading" class="loading-overlay">
        <div class="loading-content">
          <p-progressSpinner></p-progressSpinner>
          <p>Loading KIK#F1 data...</p>
        </div>
      </div>

      <div class="action-bar p-mb-3 p-d-flex p-jc-between p-ai-center">
        <div class="stats-info">
          <div class="header-container">
            <h2 class="header-title executive">
              <i class="pi pi-database title-icon"></i>
              KIK#F1 Data Management
            </h2>
            <p class="header-subtitle">Manage and analyze KIK#F1 workflow data</p>
          </div>
        </div>

        <div class="action-buttons">
          <button pButton type="button" icon="pi pi-download" label="Export CSV" class="p-button-success p-mr-2"
            (click)="exportKikF1DataCSV()"></button>
          <button pButton type="button" icon="pi pi-file-pdf" label="Export PDF" class="p-button-secondary"
            (click)="exportKikF1DataPDF()"></button>
          <button pButton type="button" icon="pi pi-refresh" label="Refresh"
            class="p-button-outlined p-button-text p-ml-2" (click)="loadAllKikF1Data()"></button>
        </div>
      </div>

          <div class="filter-section p-mb-3">
            <div class="filter-wrapper">
              <!-- Left: Search Bar -->
              <div class="search-wrapper">
                <span class="p-input-icon-left search-container">
                  <i class="pi pi-search"></i>
                  <input pInputText type="text" [(ngModel)]="searchText" (input)="onGlobalFilter($event)"
                    placeholder="Search records (customer, order, month)..." class="search-input" />
                </span>
              </div>

              <!-- Right: Filters -->
              <div class="filters-wrapper">
                <!-- Year Filter -->
                <p-dropdown [(ngModel)]="selectedYear" [options]="yearOptions" placeholder="All Years"
                  optionLabel="label" optionValue="value" (onChange)="onYearChange()"
                  class="filter-dropdown year-filter" [showClear]="true" appendTo="body">
                </p-dropdown>

                <!-- Month Filter -->
                <p-dropdown [(ngModel)]="selectedMonth" [options]="availableMonths" placeholder="All Months"
                  (onChange)="onMonthChange()" class="filter-dropdown month-filter" [showClear]="true" appendTo="body">
                </p-dropdown>

                <!-- Clear Filters -->
                <button pButton type="button" icon="pi pi-times" label="Clear Filters"
                  class="clear-filters-btn p-button-secondary p-button-outlined" (click)="clearAllFilters()">
                </button>
              </div>
            </div>
          </div>
          <p-table #dt [value]="filteredKikF1Data" [loading]="tableLoading" [paginator]="true" [rows]="10"
            scrollHeight="600px" [scrollable]="true" [globalFilterFields]="['customerName', 'orderId', 'month', 'year']"
            [rowsPerPageOptions]="[10, 25, 50, 100]" [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} KIK#F1 records"
            styleClass="p-datatable-responsive" class="custom-main-table" [sortField]="'year'" [sortOrder]="-1"
            [sortMode]="'single'">

            <ng-template pTemplate="caption">
              <div class="p-d-flex p-jc-between p-ai-center">
                <span>KIK#F1 Data Management Table</span>
                <span class="text-sm text-gray-500">
                  Sort by: Year (Newest first)
                </span>
              </div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr class="bg-gray-100">
                <th style="width: 3rem" class="p-3 text-center">
                  <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th pSortableColumn="customerName">Customer Name<p-sortIcon field="customerName"></p-sortIcon></th>
                <th pSortableColumn="year">Year<p-sortIcon field="year"></p-sortIcon></th>
                <th pSortableColumn="month">Month<p-sortIcon field="month"></p-sortIcon></th>
                <th style="width: 6rem">Week</th>
                <th pSortableColumn="value" class="text-right">Value<p-sortIcon field="value"></p-sortIcon></th>
                <th style="width: 8rem" class="text-right">Quantity</th>
                <th style="width: 8rem">Actions</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
              <tr class="hover:bg-gray-50 transition-colors" [class]="rowIndex % 2 === 0 ? 'bg-gray-50' : ''">
                <td class="p-3 text-center">
                  <p-tableCheckbox [value]="item"></p-tableCheckbox>
                </td>
                <td class="p-3">
                  <span class="p-column-title">Customer Name:</span>
                  <span class="text-sm font-medium text-blue-600 hover:text-blue-800 cursor-pointer"
                    [pTooltip]="item.customerName" pTooltipPosition="top">
                    {{ item.customerName }}
                  </span>
                </td>
                <td class="p-3">
                  <span class="p-column-title">Year:</span>
                  <div class="year-badge bg-purple-100 text-purple-800 px-2 py-1 rounded-full text-xs font-semibold">
                    {{ item.year }}
                  </div>
                </td>
                <td class="p-3">
                  <span class="p-column-title">Month:</span>
                  <div class="month-badge bg-indigo-100 text-indigo-800 px-2 py-1 rounded-full text-xs font-semibold">
                    {{ getMonthDisplay(item.month) }}
                  </div>
                </td>
                <td class="p-3 text-center">
                  <span class="p-column-title">Week:</span>
                  <span class="text-sm bg-gray-100 text-gray-800 px-2 py-1 rounded-full">
                    Week {{ item.week }}
                  </span>
                </td>
                <td class="p-3 text-right">
                  <span class="p-column-title">Value:</span>
                  <div [class]="getValueImpactClass(item.value)" class="px-2 py-1 rounded text-sm font-semibold">
                    <i class="pi pi-dollar-sign"></i>
                    {{ formatCurrency(item.value) }}
                    <div class="text-xs mt-1 opacity-75">{{ getValueImpact(item.value) }} Impact</div>
                  </div>
                </td>
                <td class="p-3 text-right">
                  <span class="p-column-title">Quantity:</span>
                  <span class="text-sm font-semibold text-green-600">
                    {{ formatQuantity(item.quantity) }}
                  </span>
                </td>
                <td class="p-3">
                  <div class="flex gap-1">
                    <button pButton type="button" icon="pi pi-eye" size="small"
                      class="p-button-rounded p-button-info p-button-text" (click)="viewKikF1Data(item)"
                      pTooltip="View Details" tooltipPosition="top"></button>
                    <button pButton type="button" icon="pi pi-pencil" size="small"
                      class="p-button-rounded p-button-success p-button-text" (click)="editKikF1Data(item)"
                      pTooltip="Edit Record" tooltipPosition="top"></button>
                    <button pButton type="button" icon="pi pi-trash" size="small"
                      class="p-button-rounded p-button-danger p-button-text" (click)="deleteKikF1Data(item)"
                      pTooltip="Delete Record" tooltipPosition="top"></button>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="10" class="text-center p-8 text-gray-500">
                  <div class="empty-state">
                    <div class="empty-icon-wrapper">
                      <i class="pi pi-inbox empty-icon"></i>
                    </div>
                    <h3 class="empty-title">No KIK#F1 Data Found</h3>
                    <p class="empty-description">
                      No KIK#F1 records are currently available.
                      <br>
                      <button pButton type="button" label="Refresh Data" icon="pi pi-refresh"
                        class="p-button-link p-button-text mt-2" (click)="loadAllKikF1Data()"></button>
                    </p>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="summary">
              <div class="p-d-flex p-jc-between p-ai-center p-p-3">
                <span class="text-sm text-gray-600">
                  Total Value: {{ getTotalValue() | currency:'USD':'symbol':'1.2-2' }}
                </span>
                <span class="text-sm text-gray-600">
                  Total Quantity: {{ getTotalQuantity() }} units
                </span>
              </div>
            </ng-template>
          </p-table>

      <!-- Details Dialog -->
      <p-dialog header="KIK#F1 Record Details" [(visible)]="showDetailsDialog" [modal]="true"
        [style]="{width: '60vw', height: '70vh'}" [closable]="true" [draggable]="false" [resizable]="true"
        [maximizable]="true">

        <div *ngIf="selectedKikF1Item" class="details-content">
          <div class="p-grid">
            <div class="p-col-12 p-md-6 p-lg-4" *ngFor="let field of getDetailFields()">
              <div class="detail-card p-mb-3">
                <label class="detail-label">{{ field.label }}:</label>
                <div class="detail-value" [innerHTML]="getFieldValue(field.key, selectedKikF1Item)"></div>
              </div>
            </div>
          </div>
        </div>

        <ng-template pTemplate="footer">
          <button pButton type="button" label="Close" icon="pi pi-times" class="p-button-text p-button-secondary"
            (click)="closeDetailsDialog()"></button>
          <button pButton type="button" label="Edit Record" icon="pi pi-pencil" class="p-button-primary"
            (click)="showDetailsDialog = false; editKikF1Data(selectedKikF1Item!)"></button>
        </ng-template>
      </p-dialog>

      <p-dialog header="Edit KIK#F1 Record" [(visible)]="showEditDialog" [modal]="true"
        [style]="{width: '48vw', maxWidth: '560px', minWidth: '480px'}" [closable]="true" [draggable]="false"
        [resizable]="false" styleClass="enhanced-dialog" [contentStyle]="{padding: '0'}">

        <div *ngIf="editingKikF1Item.id" class="enhanced-form-container">
          <form #editForm="ngForm" class="enhanced-form">
            <div class="enhanced-grid">
              <!-- Row 1 -->
              <!-- Row 1 -->
              <div class="form-row">
                <div class="form-group">
                  <label for="customerName" class="enhanced-label">
                    <span class="label-text">Customer Name</span>
                    <span class="required-indicator">*</span>
                  </label>
                  <!-- ORIGINAL SIMPLE STYLE -->
                  <input id="customerName" pInputText type="text" [(ngModel)]="editingKikF1Item.customerName!"
                    name="customerName" required class="enhanced-input" placeholder="Enter customer name" />
                </div>

                <div class="form-group">
                  <label for="year" class="enhanced-label">
                    <span class="label-text">Year</span>
                    <span class="required-indicator">*</span>
                  </label>
                  <!-- ORIGINAL SIMPLE STYLE - NO ICON WRAPPER -->
                  <p-dropdown id="year" [(ngModel)]="editingKikF1Item.year" [options]="yearOptions" optionLabel="label"
                    optionValue="value" name="year" placeholder="Select year" [showClear]="true"
                    styleClass="enhanced-dropdown">
                  </p-dropdown>
                </div>
              </div>

              <!-- Row 2 -->
              <div class="form-row">
                <div class="form-group">
                  <label for="month" class="enhanced-label">
                    <span class="label-text">Month</span>
                    <span class="required-indicator">*</span>
                  </label>
                  <!-- ORIGINAL SIMPLE STYLE -->
                  <p-dropdown id="month" [(ngModel)]="editingKikF1Item.month" [options]="availableMonths" name="month"
                    placeholder="Select month" [showClear]="true" styleClass="enhanced-dropdown">
                  </p-dropdown>
                </div>

                <div class="form-group">
                  <label for="week" class="enhanced-label">
                    <span class="label-text">Week</span>
                    <span class="required-indicator">*</span>
                  </label>
                  <!-- ORIGINAL SIMPLE STYLE -->
                  <p-dropdown id="week" [(ngModel)]="editingKikF1Item.week" [options]="weekOptions" optionLabel="label"
                    optionValue="value" name="week" placeholder="Select week" [showClear]="true"
                    styleClass="enhanced-dropdown">
                  </p-dropdown>
                </div>
              </div>

              <!-- Row 3 -->
              <div class="form-row">
                <div class="form-group">
                  <label for="value" class="enhanced-label">
                    <span class="label-text">Value (USD)</span>
                    <span class="required-indicator">*</span>
                  </label>
                  <!-- ORIGINAL SIMPLE STYLE -->
                  <input id="value" [(ngModel)]="editingKikF1Item.value" name="value" mode="currency"
                    currency="USD" locale="en-US" [min]="0" class="enhanced-input" placeholder="0.00"/>
                </div>

                <div class="form-group">
                  <label for="quantity" class="enhanced-label">
                    <span class="label-text">Quantity</span>
                  </label>
                  <!-- ORIGINAL SIMPLE STYLE -->
                  <input id="quantity" pInputText type="text" [(ngModel)]="editingKikF1Item.quantity!" name="quantity"
                    class="enhanced-input" placeholder="Enter quantity" />
                </div>
              </div>


              <!-- Status Indicator -->
              <div class="form-status">
                <div class="status-indicator" [ngClass]="{'active': editingKikF1Item.id}">
                  <div class="status-dot"></div>
                  <span class="status-text">
                    {{ editingKikF1Item.id ? 'Editing existing record' : 'Creating new record' }}
                  </span>
                </div>
              </div>
            </div>
          </form>
        </div>

        <ng-template pTemplate="footer" class="enhanced-footer">
          <div class="footer-actions">
            <button pButton type="button" label="Cancel" icon="pi pi-times"
              class="p-button-outlined p-button-secondary enhanced-btn" (click)="cancelEdit()"></button>
            <button pButton type="button" label="Save Changes" icon="pi pi-check" class="p-button-primary enhanced-btn"
              [disabled]="!editingKikF1Item.customerName || !editingKikF1Item.year" (click)="saveKikF1Data()">
            </button>
          </div>
        </ng-template>
      </p-dialog>

    </div>
  </div>
</div>